module.exports = __WEBPACK_EXTERNAL_MODULE_51__;


//////////////////
// WEBPACK FOOTER
// external {"root":"moment","commonjs2":"moment","commonjs":"moment","amd":"moment"}
// module id = 51
// module chunks = 0